import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Modal } from 'containers/misc'
import { Title } from 'components/layout'
import { form } from 'helpers/decorators'
import { Button } from 'components/misc'
import { FormattedMessage } from 'react-intl'


@form({
  form: 'bulk-action-emailing-modal',
  disableHook: true
})
class BulkActionEmailingModal extends Component {
  static propTypes = {
    modalId: PropTypes.string,
    modal: PropTypes.func,
    emailList: PropTypes.array.isRequired
  }

  render() {
    const {
      modalId,
      modal,
      emailList
    } = this.props

    return (
      <Modal id={modalId} modal={modal} customActions>
        <Title h2 intlKey="label.bulk_action_emailing">
          Email addresses of selected participants
        </Title>
        <div className="row">
          <div className="col-xs-12" style={{ marginBottom: '15px' }}>
            <p style={ {"wordWrap": "break-word"} }>{emailList ? emailList.join(';') : 'no selected participants'}</p>

            <a href={`mailto:?bcc=${emailList.join(';')}`}>
              <FormattedMessage
                id='label.prepare_new_email'
                defaultMessage='Prepare new email'
              />
            </a>
          </div>
        </div>
        <div className="row">
          <div style={{ marginBottom: '15px', margin: 'auto', textAlign: 'center' }}>
            <Button
              intlKey="button.dismiss"
              onClick={() => this.props.modal(null)}
              secondary
              type="button"
              style={{ marginRight: 10 }}
            >
              Dismiss
            </Button>
          </div>
        </div>

      </Modal>
    )
  }
}

export default BulkActionEmailingModal
